import React, { ReactNode } from "react"

import classNames from "src/classNames"

export type H4Props = {
  children: ReactNode
  className?: string
}

const H4: React.FC<H4Props> = ({ children, className = "" }) => {
  return (
    <h4 className={classNames("font-medium uppercase", className)}>
      {children}
    </h4>
  )
}

export default H4
